import React, { useState, useEffect, useMemo } from 'react';
import { MTableBodyRow } from 'material-table';
import { MTable } from 'ui/mtable/MTable';
import { CompanyFilter } from './components/CompanyFilter';
import { LogDetails } from './components/LogDetails';
import { loadCompanies } from '../../Services';
import formatters from '../../../formatters';
import { EventOptions } from '../Consts';
import { useReports } from '../../hooks/useReports';

const getColumns = () => {
    return [
        {
            field: 'id',
            title: '#',
            notFilter: true,
        },
        {
            field: 'company',
            title: 'Company',
            notFilter: true,
        },
        {
            field: 'date',
            title: 'Date',
            defaultSort: 'desc',
            notFilter: true,
            render: rowData => formatters.date(rowData.date),
            cellStyle: {
                minWidth: '170px',
            },
        },
        {
            field: 'event',
            title: 'Event',
            filterType: 'select',
            multipleFilter: true,
            filterOptions: EventOptions,
        },
        {
            field: 'changed_by',
            title: 'Changed By',
            multipleFilter: true,
        },
        {
            field: 'ip_address',
            title: 'IP Address',
            multipleFilter: true,
        },
        {
            field: 'details',
            title: 'Details',
            render: rowData => <LogDetails data={rowData.details} />,
        },
    ];
};

const logsMapping = data => {
    return data.map((item, index) => ({
        org_uuid: item.organization.uuid,
        id: index + 1,
        company: `${item.organization.business_name}`,
        date: item.date,
        event: item.event,
        changed_by: item.email,
        ip_address: item.ip_address,
        details: item.details,
    }));
};

const filterByCompanies = (logs = [], companies = []) => {
    if (companies.length === 0) {
        return logs;
    }
    const org_uuids = companies.map(company => company.uuid);
    return logs.filter(log => org_uuids.includes(log.org_uuid));
};

const EventLog = ({ dateRange, app }) => {
    const { currentUser } = app;
    const { data, isLoading, isValidating, refresh } = useReports(
        currentUser,
        'event_log',
        dateRange
    );

    const logs = useMemo(() => {
        return Array.isArray(data) ? logsMapping(data) : [];
    }, [data]);

    const [companies, setCompanies] = useState([]);
    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const [openFilter, setOpenFilter] = useState(false);

    useEffect(() => {
        loadCompanies().then(data => {
            setCompanies(data);
            setSelectedCompanies(data);
        });
    }, []);

    const handleCompanyChange = (selectedCompanies, isAllSelected) => {
        setSelectedCompanies(selectedCompanies);
    };

    const handleClickFilter = () => setOpenFilter(prev => !prev);
    const handleCloseFilter = () => setOpenFilter(false);

    return (
        <MTable
            stateKey="EventLog"
            columns={getColumns()}
            data={filterByCompanies(logs, selectedCompanies)}
            loading={isLoading || isValidating}
            title={null}
            onRefresh={refresh}
            components={{
                Row: props => {
                    props.data.id = props.index + 1;
                    return <MTableBodyRow {...props} />;
                },
            }}
            primaryFilters={[
                () => (
                    <CompanyFilter
                        onChange={handleCompanyChange}
                        onClick={handleClickFilter}
                        onClose={handleCloseFilter}
                        key="company"
                        companies={companies}
                        selected={selectedCompanies}
                        open={openFilter}
                    />
                ),
            ]}
        />
    );
};

export { EventLog };
